<div>
  <div class="panel mb-5 border-[#e0e6ed] px-0 pb-1.5 dark:border-[#1b2e4b]">
    <div class="datatable invoice-table px-5">
      <div class="panel px-0 shadow-none">
        <div class="mb-10 flex items-center justify-between">
          <h5 class="text-lg font-semibold dark:text-white-light">{{ packageTitle }} {{ "bills.plan" | translate }}</h5>
          <a (click)="openAddModal()" class="btn btn-primary cursor-pointer">
            {{ "bills.renew_now" | translate }}
          </a>
        </div>
        <div class="group">
          <div class="mb-4 flex items-center justify-between font-semibold">
            <p class="flex items-center rounded-full bg-dark px-2 py-1 text-xs font-semibold text-white-light">
              <icon-clock class="h-3 w-3 ltr:mr-1 rtl:ml-1" />
              {{ daysLeft }} {{ "bills.days_left" | translate }}
            </p>
            <p class="flex items-center rounded-full bg-dark px-2 py-1 text-xs font-semibold text-white-light">
              <icon-clock class="h-3 w-3 ltr:mr-1 rtl:ml-1" />
              {{ daysLeft }} {{ "bills.days_left" | translate }}
            </p>
            <p class="text-info">{{ packagePrice }}€ {{ "bills.per_month" | translate }}</p>
          </div>
          <div class="mb-5 h-2.5 overflow-hidden rounded-full bg-dark-light p-0.5 dark:bg-dark-light/10">
            <div
              class="relative h-full w-full rounded-full bg-gradient-to-r from-[#f67062] to-[#fc5296]"
              [ngStyle]="{
                width: getProgressWidth(),
              }"
            ></div>
          </div>
        </div>
      </div>
      <ng-template #addTaskModalTemplate>
        <div class="flex flex-col p-4" *ngIf="createPriceForm">
          <div class="!pb-5 text-xl">
            {{ "bills.add_bill" | translate }}
          </div>
          <form class="text-sm" (submit)="addBill()" [formGroup]="createPriceForm">
            <div class="mb-5" [ngClass]="wrongStartDateInput ? 'has-error' : ''">
              <label for="startDate">{{ "bills.date_starts" | translate }}</label>
              <input mwlFlatpickr formControlName="startDate" [options]="datePickerOptions" id="startDate" type="text" class="form-input" />
            </div>

            <div class="mb-5" [ngClass]="wrongEndDateInput ? 'has-error' : ''">
              <label for="endDate">{{ "bills.date_ends" | translate }}</label>
              <input mwlFlatpickr formControlName="endDate" [options]="datePickerOptions" id="endDate" type="text" class="form-input" />
            </div>

            <div class="mb-5">
              <label for="remainingTime">{{ "bills.remaining_time" | translate }}</label>
              <h2>{{ remainingTime }}</h2>
            </div>

            <div class="mb-5">
              <label for="price">{{ "bills.price" | translate }}</label>
              <div class="flex">
                <input
                  id="price"
                  type="text"
                  formControlName="price"
                  [placeholder]="'bills.enter_price' | translate"
                  class="form-input flex-1 ltr:rounded-l-md ltr:rounded-r-none rtl:rounded-r-none rtl:border-l-0"
                  required
                />
                <div
                  class="flex items-center justify-center border border-[#e0e6ed] bg-[#eee] px-3 font-semibold dark:border-[#17263c] dark:bg-[#1b2e4b] ltr:rounded-r-md ltr:border-l-0 rtl:rounded-l-md rtl:border-r-0"
                >
                  €
                </div>
              </div>
            </div>
            <div class="mb-5">
              <label>{{ "billing.currency" | translate }}</label>
              <ng-select [items]="options" formControlName="currencyCode" bindValue="value" bindLabel="label" [searchable]="false" [clearable]="false" class="custom-multiselect" [tabFocusOnClearButton]="false">
              </ng-select>
            </div>

            <div class="flex items-center gap-2 mb-5">
              <div>
                <label for="customDoubleCopy" class="relative h-6 w-12">
                  <input type="checkbox" formControlName="useIBAN" class="custom_switch peer absolute z-10 h-full w-full cursor-pointer opacity-0" id="customDoubleCopy" name="copyOption" />
                  <span
                    for="customDoubleCopy"
                    class="outline_checkbox bg-white block h-full rounded-full border-2 border-[#ebedf2] before:absolute before:bottom-1 before:left-1 before:h-4 before:w-4 before:rounded-full before:bg-[#ebedf2] before:bg-center before:bg-no-repeat before:transition-all before:duration-300 peer-checked:border-primary peer-checked:before:left-7 peer-checked:before:bg-primary dark:border-white-dark dark:before:bg-white-dark"
                  ></span>
                </label>
              </div>
              <div class="mb-2">
                {{ "billing.use_iban" | translate }}
              </div>
            </div>

            <div class="mt-8 flex items-center justify-end ltr:text-right rtl:text-left">
              <button *ngIf="!isLoading" type="button" class="btn btn-outline-danger" (click)="addTaskModal.close()">
                {{ "bills.cancel" | translate }}
              </button>
              <button *ngIf="!isLoading" type="submit" class="btn btn-primary ltr:ml-4 rtl:mr-4">
                {{ "bills.add" | translate }}
              </button>

              <button *ngIf="isLoading" type="button" class="btn btn-primary ltr:ml-4 rtl:mr-4">
                <span class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"></span>
                {{ "bills.loading" | translate }}
              </button>
            </div>
          </form>
        </div>
      </ng-template>

      <ng-datatable
        [rows]="items"
        [columns]="cols"
        [sortable]="true"
        skin="whitespace-nowrap bh-table-hover"
        firstArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M13 19L7 12L13 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path opacity="0.5" d="M16.9998 19L10.9998 12L16.9998 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
        lastArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M11 19L17 12L11 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path opacity="0.5" d="M6.99976 19L12.9998 12L6.99976 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg> '
        previousArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M15 5L9 12L15 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
        nextArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
      >
        <ng-template slot="id" let-value="data">
          {{ value.id }}
        </ng-template>
        <ng-template slot="filepath" let-value="data">
          <a [routerLink]="['/bill-preview/', value.id]" class="font-semibold text-primary underline hover:no-underline">#{{ value.filepath }}</a>
        </ng-template>
        <ng-template slot="startDate" let-value="data">
          {{ value.startDate | date: "dd.MM.yyyy" }}
        </ng-template>
        <ng-template slot="endDate" let-value="data">
          {{ value.endDate | date: "dd.MM.yyyy" }}
        </ng-template>
        <ng-template slot="createdDate" let-value="data">
          {{ value.createdDate | date: "dd.MM.yyyy" }}
        </ng-template>
        <ng-template slot="updatedDate" let-value="data">
          {{ value.updatedDate | date: "dd.MM.yyyy" }}
        </ng-template>

        <ng-template slot="deliveryStatus" let-value="data">
          <div hlMenu class="dropdown inline-flex">
            <button type="button" class="btn cursor-default" [ngClass]="getDeliveryStatusClass(value.isSent)">
              <span *ngIf="value.isSent">{{ "billing.sent" | translate }}</span>
              <span *ngIf="!value.isSent">{{ "billing.not_sent" | translate }}</span>
            </button>
          </div>
        </ng-template>

        <ng-template slot="status" let-value="data">
          <div hlMenu class="dropdown inline-flex">
            <button type="button" class="btn cursor-default" [ngClass]="getStatusClass(value.status)">
              {{ getBillStatus(value.status) }}
            </button>
          </div>
        </ng-template>
        <ng-template slot="actions" let-value="data">
          <div class="flex w-max items-center justify-between">
            <div hlMenu class="dropdown">
              <a hlMenuButton href="javascript:;">
                <icon-horizontal-dots class="rotate-90 opacity-70" />
              </a>
              <div #dropdownPlaceholder *hlMenuItems>
                <app-message-portal #messagePortalComponent @toggleAnimation (portalAttached)="onPortalAttached()">
                  <li>
                    <a *hlMenuItem="let menuItem" [routerLink]="['/bill-preview', contractId, value.id]">
                      <icon-eye class="shrink-0 ltr:mr-2 rtl:ml-2" />
                      {{ "bills.preview" | translate }}
                    </a>
                  </li>
                  <li *ngIf="value.status === 1">
                    <a href="javascript:;" *hlMenuItem="let menuItem" (click)="updateStatus(value.id, 0)">
                      <icon-dollar-sign-circle class="shrink-0 ltr:mr-2 rtl:ml-2" />
                      {{ "bills.set_paid" | translate }}
                    </a>
                  </li>
                  <li *ngIf="value.status === 0">
                    <a href="javascript:;" *hlMenuItem="let menuItem" (click)="updateStatus(value.id, 1)">
                      <icon-dollar-sign-circle class="shrink-0 ltr:mr-2 rtl:ml-2" />
                      {{ "bills.set_unpaid" | translate }}
                    </a>
                  </li>
                  <li>
                    <a href="javascript:;" *hlMenuItem="let menuItem" (click)="openDeleteModal(value.id)">
                      <icon-trash class="shrink-0 ltr:mr-2 rtl:ml-2" />
                      {{ "delete_quick_label" | translate }}
                    </a>
                  </li>
                </app-message-portal>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-datatable>
    </div>
  </div>
</div>

<ng-template #deleteConfirmationTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ "billing.delete_title" | translate }}</div>
    <div>
      <span>{{ "billing.delete_info" | translate }} </span>
    </div>
    <div class="mt-4 flex justify-end">
      <button class="rounded-lg bg-gray-200 px-4 py-2 text-gray-800 hover:bg-gray-300" (click)="closeDeleteModal()">{{ "cancel" | translate }}</button>
      <button class="btn btn-danger ml-3" [disabled]="isLoadingDelete" (click)="handleDelete()">
        <ng-container *ngIf="isLoadingDelete; else alternateTranslation">
          <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
          {{ "deleting" | translate }}
        </ng-container>
        <ng-template #alternateTranslation>
          {{ "delete_quick_label" | translate }}
        </ng-template>
      </button>
    </div>
  </div>
</ng-template>
